var app = angular.module('leonardo');

var WPFormDate = function (FilterService, $timeout, AuthDataService, RecurrenceService) {
  return {
    restrict: 'A',
    require: ['^form', 'ngModel'],
    scope: {
      disabled: '=ngDisabled',
      required: '=ngRequired',
      label: '@',
      inline: '=?',
      timeZone: '@',
      placeholder: '@',
      startDate: '@',
      endDate: '@',
      filter: '@',
      ngChange: '&',
      name: '@',
      help: '=?'
    },
    templateUrl: 'views/templates/form/form-date.html',
    link: function (scope, element, attrs, ctrls) {
      scope.formCtrl = ctrls[0];
      scope.ngModelCtrl = ctrls[1];
      scope.country = AuthDataService.authData && AuthDataService.authData.account ? angular.copy(AuthDataService.authData.account.country) : null;
      scope.defaultDateMask = scope.country && scope.country.date_mask ? scope.country.date_mask.toString() : 'MM-DD-YYYY';
      scope.defaultDateMask = attrs.formatDate ? 'YYYY-MM-DD' : scope.defaultDateMask;
      scope.$input = scope.inline ? element.find('.form-date-inline-widget') : element.find('.form-date-input');
      scope.validFormat = /^(0[1-9]|1[0-2])[\/\-\.](0[1-9]|1\d|2\d|3[01])[\/\-\.](19|20)\d{2}$/;
      scope.timeZone = scope.timeZone || jstz.determine().name();

      scope.regex = {
        month: new RegExp(/(0?[1-9]|1[0-2])/),
        day: new RegExp(/(0?[1-9]|1\d|2\d|3[01])/),
        year: new RegExp(/(19|20)\d{2}/),
        separator: new RegExp(/(\/|-|\.| |, )/)
      };

      scope.getMask = function () {
        var result = angular.copy(scope.defaultDateMask);
        var array = result.split('-');
        if (array.length <= 1) {
          array = result.split('/');
        }
        if (array.length <= 1) {
          array = result.split(' ');
          if (array.length > 1) {
            var first = array[0].split(', ');
            if (first.length <= 1) {
              var second = array[1].split(', ');
              array = first.concat(second);
            } else {
              array = first.concat([array[1]]);
            }
          }
        }
        var format = '';
        angular.forEach(array, function (key, index) {
          switch (key) {
            case 'MM':
            case 'M':
              format += scope.regex.month.source;
              break;
            case 'DD':
            case 'D':
              format += scope.regex.day.source;
              break;
            case 'YYYY':
              format += scope.regex.year.source;
              break;
          }
          if (index < array.length - 1) {
            format += scope.regex.separator.source;
          }
        });
        scope.validFormat = new RegExp(format);
        if (!isNull(result)) {
          result = result.toString();
          result = result.replaceAll('M', '9');
          result = result.replaceAll('D', '9');
          result = result.replaceAll('Y', '9');
        } else {
          result = '99-99-9999';
        }
        return result;
      };

      scope.mask = scope.mask ? scope.mask : scope.getMask();

      if (!scope.inline) {
        angular.element(scope.$input).mask(scope.mask);
      }

      scope.getDate = function (option) {
        let date;
        switch (option) {
          case 'today':
            date = moment();
            break;
          case 'yesterday':
            date = moment().subtract(1, 'days');
            break;
          case 'tomorrow':
            date = moment().add(1, 'days');
            break;
          default:
            date = moment(option);
            break;
        }
        let dateTimezone = scope.timeZone ? date.tz(scope.timeZone) : date;
        return moment(dateTimezone.format('YYYY-MM-DDTHH:mm:ss'));
      };

      scope.formatValid = function (value) {
        var formatValid = scope.validFormat.test(value);
        if (formatValid) {
          if (scope.endDate) {
            formatValid = moment(value, scope.defaultDateMask).format('YYYY-MM-DD') <= scope.getDate(scope.endDate).format('YYYY-MM-DD');
          }
          if (scope.startDate) {
            formatValid = moment(value, scope.defaultDateMask).format('YYYY-MM-DD') >= scope.getDate(scope.startDate).format('YYYY-MM-DD');
          }
        }
        return formatValid;
      };

      scope.getModelValue = function () {
        var date = scope.ngModelCtrl.$modelValue;
        if (date) {
          return moment(date).toDate();
        }
        return false;
      };

      scope.getButtonToday = function () {
        let today = scope.getDate('today').format('YYYY-MM-DD');
        if (scope.endDate && scope.getDate(scope.endDate).format('YYYY-MM-DD') < today) {
          return false;
        }
        if (scope.startDate && scope.getDate(scope.startDate).format('YYYY-MM-DD') > today) {
          return false;
        }
        return true;
      };

      scope.setDate = function (newValue) {
        if (newValue) {
          scope.ngModelCtrl.$setViewValue(newValue);
          if (scope.filter) {
            FilterService.setFilter(scope.filter, newValue);
          }
        } else {
          if (scope.ngModelCtrl.$modelValue) {
            scope.ngModelCtrl.$setViewValue('');
          }
          if (scope.filter) {
            FilterService.removeFilter(scope.filter);
          }
        }
      };

      scope.ngModelCtrl.$render = function () {
        scope.date = angular.copy(scope.ngModelCtrl.$modelValue);
        if (!scope.date && scope.filter) {
          scope.date = FilterService.getFilter(scope.filter);
        }
        if (scope.date) {
          scope.$input.datepicker('setDate', moment(scope.date).toDate());
        }
      };

      scope.options = {
        format: attrs.format || scope.defaultDateMask.toLowerCase(),
        orientation: attrs.orientation || 'auto',
        autoclose: attrs.notAutoclose === undefined,
        todayBtn: scope.getButtonToday() ? 'linked' : false,
        minViewMode: attrs.viewMode || 'days',
        forceParse: false
      };

      scope.$input.datepicker(scope.options);

      scope.$input.datepicker().on('changeDate', function (e) {
        var inputVal = moment(scope.$input.val()).format('YYYY-MM-DD');
        var datepickerVal = moment(e.date).format('YYYY-MM-DD');
        if (angular.equals(inputVal, datepickerVal) || scope.inline) {
          if (e.date) {
            if (attrs.viewMode === 'months') {
              scope.date = RecurrenceService.getValue('monthly', e.date);
            } else {
              scope.date = moment(e.date).format('YYYY-MM-DD');
            }
          } else {
            scope.date = '';
          }
          scope.setDate(scope.date);
          scope.ngChange();
        }
      });

      scope.$input.datepicker().on('clearDate', function (e) {
        scope.date = '';
      });

      scope.setStartDate = function (startDate) {
        let currentValue = scope.getModelValue();
        if (startDate) {
          var m = scope.getDate(startDate);
          scope.$input.datepicker('setStartDate', m.toDate());
          if (!currentValue) {
            return;
          }
          if (m.toDate() >= currentValue) {
            scope.$input.datepicker('setDate', m.toDate());
          } else {
            scope.$input.datepicker('setDate', currentValue);
          }
        } else {
          scope.$input.datepicker('setStartDate', false);
        }
      };

      scope.setEndDate = function (endDate) {
        let currentValue = scope.getModelValue();
        if (endDate) {
          var m = scope.getDate(endDate);
          scope.$input.datepicker('setEndDate', m.toDate());
          if (!currentValue) {
            return;
          }
          if (m.toDate() <= currentValue) {
            scope.$input.datepicker('setDate', m.toDate());
          } else {
            scope.$input.datepicker('setDate', currentValue);
          }
        } else {
          if (attrs.dateNoFuture) {
            scope.$input.datepicker('setEndDate', scope.getDate('today').toDate());
          } else {
            scope.$input.datepicker('setEndDate', false);
          }
        }
      };

      scope.$watch('startDate', function (newValue) {
        $timeout(function () {
          scope.setStartDate(newValue);
        }, 10);
      });

      scope.$watch('endDate', function (newValue) {
        $timeout(function () {
          scope.setEndDate(newValue);
        }, 10);
      });

      scope.$on('filter-date-range:filter-changed', function ($event, key, value, disable) {
        if (key === scope.filter) {
          if (value) {
            scope.date = value;
          } else {
            scope.date = '';
          }
          $timeout(function () {
            scope.disable = disable;
          }, 0);
        }
      });

      scope.$on('filter-service:filter-changed', function ($event, key, value) {
        if (key === scope.filter) {
          if (value) {
            scope.date = value;
          } else {
            scope.date = '';
          }
        }
      });

      scope.$on('filter-service:filter-removed', function ($event, key) {
        if (key === scope.filter) {
          scope.date = '';
        }
      });

      scope.$on('value-date-range:status-changed', function ($event, keys, disable) {
        if (_.contains(keys, scope.filter) || _.contains(keys, scope.name)) {
          scope.disable = !!disable;
        }
      });

      scope.$watch('timeZone', function (newValue, oldValue) {
        if (angular.equals(newValue, oldValue)) {
          return;
        }
        if (scope.startDate) {
          scope.setStartDate(scope.startDate);
        }
        if (scope.endDate) {
          scope.setEndDate(scope.endDate);
        }
      });

      scope.$watch('disabled', function (newValue, oldValue) {
        if (angular.equals(newValue, oldValue)) {
          return;
        }
        if (newValue) {
          scope.$input.datepicker('hide');
          angular.element('.datepicker th').on('click', function (event) {
            event.preventDefault();
            event.stopPropagation();
          });
          $timeout(function () {
            angular.element('.datepicker td').on('click', function (event) {
              event.preventDefault();
              event.stopPropagation();
            });
          }, 10);
        } else {
          angular.element('.datepicker th').off('click', function () {
            // This is intentional do_something blank function
          });
          angular.element('.datepicker td').off('click', function () {
            // This is intentional do_something blank function
          });
        }
      });

      scope.$watch('inline', function (newValue, oldValue) {
        if (angular.equals(newValue, oldValue)) {
          return;
        }
        scope.$input = newValue ? element.find('.form-date-inline-widget') : element.find('.form-date-input');
        scope.$input.datepicker(scope.options);
      });

      scope.$watch('date', function (newValue, oldValue) {
        if (angular.equals(newValue, oldValue)) {
          return;
        }
        scope.setDate(newValue);
        $timeout(function () {
          scope.$input.datepicker('setDate', scope.getModelValue());
        }, 0);
      });

      scope.$watch('value', function (newValue) {
        if (scope.formatValid(newValue)) {
          scope.date = moment(newValue, scope.defaultDateMask).format('YYYY-MM-DD');
        }
        scope.ngModelCtrl.$validate();
      });

      scope.$on('$destroy', function () {
        scope.$input.datepicker('remove');
        angular.element('.datepicker-inline th').off('click', function () {
          // This is intentional do_something blank function
        });
        angular.element('.datepicker-inline td').off('click', function () {
          // This is intentional do_something blank function
        });
      });

      element.find('input').bind('keydown keypress', function (event) {
        let value = scope.ngModelCtrl.$viewValue || scope.value;
        if (event.key === 'Backspace') {
          if (scope.formatValid(moment(value).format(scope.defaultDateMask))) {
            scope.value = '';
            scope.date = '';
            scope.$apply(scope.value);
            scope.$apply(scope.date);
            $timeout(function () {
              scope.$apply(angular.element(scope.$input).focus());
            }, 0);
          }
        } else {
          if (!_.contains([8, 9, 13, 16, 46], event.keyCode) && (event.keyCode < 47 || event.keyCode > 57)) {
            event.preventDefault();
          }
        }
      });

      scope.ngModelCtrl.$validators.format = function () {
        if (scope.required) {
          return scope.formatValid(scope.value);
        } else {
          return isNull(scope.value) || scope.formatValid(scope.value);
        }
      };
    }
  };
};

app.directive('wpFormDate', ['FilterService', '$timeout', 'AuthDataService', 'RecurrenceService', WPFormDate]);
